/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maccaption_MccInputs */



/**
* | output |
* | --- |
* | "MacCaption (.mcc)" |
*
* @param {Maccaption_MccInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maccaption_mcc = /** @type {((inputs?: Maccaption_MccInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maccaption_MccInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
	if (locale === "de") return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
	if (locale === "it") return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Título de Mac (.mcc)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マックキャプション (.mcc)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैककैप्शन (.mcc)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
	return /** @type {LocalizedString} */ ("MacCaption (.mcc)")
});